import { css } from 'linaria';
import { StylesMap } from 'types/utils';
import { AdaptiveSize } from './button-types';

export const adaptiveSizeStylesMap: StylesMap<AdaptiveSize> = {
  l: css`
    &&& {
      @media (--to-tablet) {
        padding: 10px 20px;
        font-size: 14px;
        line-height: 20px;
      }
    }
  `,
  m: css`
    && {
      @media (--to-tablet) {
        padding: 4px 10px;
        font-size: 14px;
        line-height: 20px;
      }
    }
  `,
};
